import * as React from "react";
import ReactTooltip from "react-tooltip";
import { Button, Header, Grid, Modal } from "semantic-ui-react";
import Piece from "../Piece";
import { Location } from "history";
import { Quad, GraphicData } from "../../types";
import RowWithContent from "./Grid/RowWithContent";
import WrappedModal from "../WrappedModal";

interface IProps {
	data: (Quad | GraphicData)[];
	navigate: (path: string) => void;
	curPath: Location;
}

interface IState {
	modalOpen: boolean;
	modalContent: string;
	modalTitle: string;
}

class SubQuadNavigation extends React.Component<IProps, IState> {
	state = {
		modalContent: "",
		modalOpen: false,
		modalTitle: ""
	};

	makeGrid = (): React.ReactNode => {
		const props = this.props;
		let rows = 1;
		let columns = 1;
		//TODO: Make less brittle
		if (props.data.length == 6) {
			(columns = 2), (rows = 3);
		} else if (props.data.length == 9) {
			(columns = 3), (rows = 3);
		}

		let result = [];
		let counter = -1;

		for (let curRow = 0; curRow < rows; curRow++) {
			result.push(
				<RowWithContent
					itemsPerRow={columns}
					renderItem={j => {
						// j == curColumn
						let index = counter + 1;
						counter = index;
						if (!props.data[index]) return null;

						if (props.data[index].hasOwnProperty("graphic")) {
							return (
								<div
									style={{
										backgroundImage: `url(${(props.data[
											index
										] as GraphicData).imgUrl ||
											"//via.placeholder.com/175x175"})`,
										display: "block",
										width: "100%",
										height: "220px",
										alignSelf: "center",
										backgroundSize: "cover"
									}}
								/>
							);
						} else {
							if (props.data[index]) {
								let info = props.data[index] as Quad;
								return (
									<Piece
										right={
											curRow == rows - 1 &&
											j != columns - 1
										}
										left={curRow == 0 && j != 0}
										// left={true}
										up={j == columns - 1 && curRow != 0}
										down={
											j != columns - 1 &&
											curRow != rows - 1
										}
										colour={info.colour}
										key={info.id}
										name={info.title}
										popoverText={info.question}
										handlePencil={() =>
											props.navigate(
												`${location.pathname}/${
													info.id
												}/answer`
											)
										}
										handleQuestion={() =>
											this.setState({
												modalOpen: true,
												modalContent: info.question,
												modalTitle: info.title
											})
										}
										partnerLink={info.partnerLink}
									/>
								);
							} else {
								return null;
							}
						}
					}}
					direction={
						curRow == 0
							? "left"
							: curRow == rows - 1
								? "right"
								: "none"
					}
				/>
			);

			//create Configuration
		}

		return <Grid columns={columns as any}>{result}</Grid>;
	};

	handleClose = () => this.setState({ modalOpen: false });

	render() {
		return (
			<>
				<ReactTooltip />
				{this.makeGrid()}
				<WrappedModal
					content={this.state.modalContent}
					title={this.state.modalTitle}
					isOpen={this.state.modalOpen}
					onClose={this.handleClose}
				/>
			</>
		);
	}
}

export default SubQuadNavigation;



// WEBPACK FOOTER //
// ./src/components/SubQuadNavigation/SubQuadNavigation.tsx